import { Link } from "wouter";

export function PrivacyFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-auto border-t bg-muted/50">
      <div className="container mx-auto px-4 py-4">
        <div className="flex flex-col items-center gap-2 text-xs text-muted-foreground">
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1">
            <Link
              href="/privacy-notice"
              className="hover:text-foreground hover:underline transition-colors"
            >
              Privacy Policy
            </Link>
            <span className="text-muted-foreground/50 hidden sm:inline">•</span>
            <Link
              href="/cookie-policy"
              className="hover:text-foreground hover:underline transition-colors"
            >
              Cookie Policy
            </Link>
            <span className="text-muted-foreground/50 hidden sm:inline">•</span>
            <Link
              href="/terms-of-use"
              className="hover:text-foreground hover:underline transition-colors"
            >
              Terms of Use
            </Link>
            <span className="text-muted-foreground/50 hidden sm:inline">•</span>
            <a
              href="https://www.asaferrisk.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-foreground hover:underline transition-colors"
            >
              Main website
            </a>
          </div>
          <p className="text-center">
            © {year} A Safer Risk Ltd. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
